import axios from "axios";
import { API_URL } from "const/constants";

const EMPTY_REPORT = { universities: [], totals: null };

export const fetchUniversityAdmissionSummary = async () => {
  const res = await axios.get(`${API_URL}/university/admission-summary`);
  return res?.data?.data ?? EMPTY_REPORT;
};
